export function MetricsGrid({ stats }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <div className="bg-white border border-gray-200 p-6 rounded-xl shadow-sm" data-testid="stat-referrals">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-2">Total Referrals</p>
        <p className="text-4xl font-black">{stats?.total_referrals || 0}</p>
      </div>
      <div className="bg-white border border-gray-200 p-6 rounded-xl shadow-sm" data-testid="stat-earned">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-2">Total Earned</p>
        <p className="text-4xl font-black text-green-600">${stats?.total_earned?.toFixed(2) || "0.00"}</p>
      </div>
      <div className="bg-white border border-gray-200 p-6 rounded-xl shadow-sm" data-testid="stat-pending">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-2">Pending Balance</p>
        <p className="text-4xl font-black text-[#0066FF]">${stats?.pending_earnings?.toFixed(2) || "0.00"}</p>
      </div>
      <div className="bg-white border border-gray-200 p-6 rounded-xl shadow-sm" data-testid="stat-rate">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-2">Commission Rate</p>
        <p className="text-4xl font-black">{stats?.commission_rate || "20%"}</p>
      </div>
    </div>
  );
}
